import indot from "../../assets/sponsor-logo/indot.png";

export const bronze = [
    {
        img: indot,
        link: "https://indotphotobook.com/web/home",
        insta: "https://instagram.com/indotweddingalbum_printers?igshid=YmMyMTA2M2Y=",
        width: "80%",
        height: "",
    },
]